import { render, staticRenderFns } from "./FilesPopup.vue?vue&type=template&id=6e1c82de&scoped=true"
import script from "./FilesPopup.vue?vue&type=script&lang=js"
export * from "./FilesPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1c82de",
  null
  
)

export default component.exports